export default {"src":"/_next/static/media/info-button.2a3f5dc7.svg","height":16,"width":16};